export const FacebookIcon = () => (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="ri:facebook-fill">
            <path
                id="Vector"
                d="M9.04961 9.4H10.5496L11.1496 7H9.04961V5.8C9.04961 5.182 9.04961 4.6 10.2496 4.6H11.1496V2.584C10.954 2.5582 10.2154 2.5 9.43541 2.5C7.80641 2.5 6.64961 3.4942 6.64961 5.32V7H4.84961V9.4H6.64961V14.5H9.04961V9.4Z"
                fill="#6B7682"
            />
        </g>
    </svg>
);
